import { render, staticRenderFns } from "./ListSIT.vue?vue&type=template&id=ec2d4ad6&"
import script from "./ListSIT.vue?vue&type=script&lang=js&"
export * from "./ListSIT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports